import { userSettingsApi } from "./get-user-settings"

import type { UpdateUserSettingsRequest, UpdateUserSettingsResponse } from "./types"

export const updateUserSettingsApi = userSettingsApi.injectEndpoints({
  endpoints: builder => ({
    updateUserSettings: builder.mutation<UpdateUserSettingsResponse, UpdateUserSettingsRequest>({
      query: body => ({
        url: "/api/v1/user/settings",
        method: "PUT",
        body
      }),
      invalidatesTags: (_result, error) => (error ? [] : ["UserSettings"])
    })
  })
})

export const { useUpdateUserSettingsMutation } = updateUserSettingsApi
